import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("reminders", {
    confirmSendReminder: "Send newsletter now",
    successSubmitReminder: "The mailing will be processed shortly",
    broadcast: "Broadcast",
    mailing: "Newsletter",
    editing: "Editing",
    mailSubject: "Subject of the letter",
    availableValues: "Available values",
    mailingType: "Mailout type",
    autoMailingType: "automatic",
    manualMailingType: "added manually",
    mailTemplate: "Letter Template",
    mailingMethod: "Mailing method",
    mailingDatetime: "Date and time of sending",
    mailingTime: "Sending time",
    addRecipients: "Add recipients",
    watch: "Watch",
    save: "Save",
    back: "Back",
    emailError: "Invalid email format",
    recipients: "Recipients",
    participationFormat: "Participation format",
    additionalCriterion: "Additional criterion for distribution",
    additionalCriterionCondition: `The user has viewed at least <b>X</b> and
    no more than <b>Y</b> of the total duration.`,
    additionalCriterionMeashure: "Select a calculus measure for X and Y",
    set: "Set",
    uploadEmailsFromExcel: "Upload participants from excel",
    email: "Mail",
    add: "Add",
    close: "Close",
    sheetInfo: `Select the column and first row number containing the required
    email addresses.`,
    sheet: "Sheet",
    column: "Column",
    firstRowNumber: "First row number",
    apply: "Apply",
    forTicketHolders: "For ticket holders",
    addMailing: "Add mailing list",
    recipientSource: "Recipients Source",
    templateTitle: "Template title",
    status: "Status",
    actions: "Actions",
    edit: "Edit",
    sendNow: "Send now",
    remove: "Remove",
    application: "Application",
    refusal: "Refusal",
    viewer: "Viewer",
    moderator: "Moderator",
    formatAll: "All by default",
    online: "Online",
    offline: "Offline",
    registeredType: "For authorized",
    customType: "Specified list",
    registeredSource: "Registration",
    watchedSource: "Viewers",
    customSource: "Custom List",
    ticketSource: "Ticket Holders",
    statusWaiting: "Waiting",
    statusProgress: "In progress",
    statusError: "Error",
    statusDone: "Completed",
    manualMailingMethod: "Manually",
    timeMailingMethod: "At the specified time",
    everydayMailingMethod: "Every day",
    viewTypeBroadcast: "Throughout the broadcast",
    viewTypeHall: "In a specific hall",
    viewTypeEpisode: "In a specific episode",
    meashureTypeMinutes: "minutes",
    noCustomTemplatesFound: "No custom templates found",
    setMailSubject: "Specify the subject of the letter",
    useAdditionalCriterion: "Use additional criteria",
    removeReminder: "Delete newsletter",
    no: "No",
    yes: "Yes",
    statistics: "Statistics",
    generatedReminder: "Generated newsletter",
    role: "Role",
    whenToSend: "When to send",
    setTemplate: "Specify a template",
    setReminderSubject: "Specify the subject of the newsletter",
    setTemplateAndTopic: "Select a newsletter template and topic",
    choose: "Choose",
    cancel: "Cancel",
    periodicSendStartDate: "Period start date and time",
    periodicSendEndDate: "Period end date and time",
    optional: "optional",
    setViewingType: "Set view type",
    statisticSourse: "Viewers from statistics",
    letterType: "Letter type",
    systemicReminder: "Systemic",
    customReminder: "Custom",
    listOfRecipients: "List of recipients",
    sent: "Sent",
    notSent: "Not sent",
    inQueue: "In queue",
    recipientsStatuses: `
        <b>Sent:</b><br />
        It means that the letter was successfully transferred to the SMTP server and is in the process of further processing.
        This does not guarantee that the email was successfully delivered to the final recipient.<br />
        <b>Sending error:</b><br />
        Can be used to indicate a situation where the SMTP server has rejected an email due to problems with settings, authentication or other reasons.<br />
        <b>Queue:</b><br />
        Indicates that the letter is queued for sending and has not yet been delivered to the SMTP server.
        This status may mean that the system is waiting for the letter to be sent, and its actual delivery will be made shortly.<br />
    `,
});
